import { FC } from "react";
import { NotificationPreferencesView } from "../../../../modules/preferences/views/notification-preferences-view/NotificationPreferencesView";

export const NotificationPreferencesRoute: FC = () => {
    return (
        <NotificationPreferencesView />
    )
}